var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as ShowLoyaltyDialog from '@ori-events/show-loyalty-dialog';
export const rootEl = document.getElementById('loyalty-dialog-root');
export const cultureInfo = document.getElementById('culture');
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
__webpack_public_path__ = rootEl.dataset.appUrl || ''; // eslint-disable-line
const init = () => __awaiter(void 0, void 0, void 0, function* () {
    // tslint:disable-next-line: space-in-parens
    const appRender = yield import(/* webpackChunkName: "app" */ './AppRender');
    window.addEventListener(ShowLoyaltyDialog.Name, ((event) => appRender.render(event.detail)));
});
init().catch((error) => {
    throw error;
});
